.<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Models />
  </div>
</template>
  
  <script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Models from "../../components/GestionEmpleados/Views/Employee/Models.vue";
export default {
  components: { LandingToolbar, Models },
};
</script>
  
  